import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgGivingMoney = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="65"
        viewBox="0 0 64 65"
        width="64"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clip-path="url(#clip0_2823_37616)">
            <rect
                fill="#EDEBEB"
                height="64.0001"
                rx="32"
                width="64.0001"
                y="0.21875"
            />
            <path
                d="M12.0005 26.1077L29.193 12.9573C30.3651 12.0617 31.9788 12.0185 33.1964 12.8526L51.7695 25.2188L51.7695 49.2188L12.4875 50.0291L12.0005 26.1077Z"
                fill="white"
            />
            <path
                d="M47.1601 36.7831L17.8697 38.5747L16.618 18.1086C16.5461 16.9326 17.4411 15.9209 18.6171 15.849L43.6488 14.318C44.8248 14.2461 45.8365 15.1411 45.9084 16.3171L47.1601 36.7831Z"
                fill="#B5ADAD"
            />
            <path
                d="M32.0756 34.5164L33.2745 34.4641L33.2122 33.0369C35.9838 32.7633 37.4703 31.0016 37.3772 28.8703C37.2734 26.4916 35.1676 25.859 33.9331 25.5316L32.8699 25.1967L32.7452 22.3423C33.4973 22.5383 34.132 23.1016 34.43 23.8131L36.667 22.6477C36.2655 21.3116 34.7785 20.0038 32.6364 19.8494L32.5766 18.4793L31.3777 18.5317L31.4367 19.8827C29.1805 20.1719 27.4367 21.7161 27.5347 23.9616C27.6386 26.3403 29.9603 27.1159 31.213 27.4235L31.7724 27.5707L31.9028 30.5583C31.0572 30.4046 30.2893 29.847 29.8588 28.7219L27.3992 29.5919C28.0433 31.6801 29.719 32.9415 32.0125 33.0702L32.0756 34.5164ZM30.3196 23.554C30.2922 22.926 30.6917 22.4701 31.543 22.3185L31.6527 24.8304C30.8782 24.5592 30.3495 24.2391 30.3196 23.554ZM33.1041 30.563L32.987 27.8799C33.8368 28.1288 34.4226 28.4464 34.4558 29.2076C34.4857 29.8926 33.9166 30.3941 33.1041 30.563Z"
                fill="white"
            />
            <path
                d="M12 26.1082L32.2229 39.9061L12.2695 51.2188L12 26.1082Z"
                fill="#F8F8F8"
            />
            <path
                d="M51.7696 25.2187L31.4468 40.2295L51.7696 50.7188L51.7696 25.2187Z"
                fill="#F8F8F8"
            />
            <path
                d="M51.7695 50.7187L34.0907 37.9493C32.8843 37.102 31.2702 37.1252 30.0891 38.0066L12.2695 51.2187L51.7695 50.7187Z"
                fill="#DAD7D7"
            />
        </g>
        <defs>
            <clipPath id="clip0_2823_37616">
                <rect
                    fill="white"
                    height="64.0001"
                    transform="translate(0 0.21875)"
                    width="64.0001"
                />
            </clipPath>
        </defs>
    </svg>
);

export const GivingMoneyIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={SvgGivingMoney}
        fontSize={fontSize}
    />
);
